import { useCallback } from 'react';
import { useTranslationMipManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import { DATE_FORMATS, formatStringDateToUI } from '@dealstack/shared/lib/format/dates/date';

export const useInvestmentReference = () => {
	const tMipManage = useTranslationMipManage();

	return useCallback(
		(investmentWorkflowType: string, isReleased: boolean, date: string): string => {
			const workflowLabels: Record<string, string> = {
				JOINER_CREATE: tMipManage('investors.expanded_row.workflow.joiner'),
				JOINER: tMipManage('investors.expanded_row.workflow.joiner'),
				ALLOCATION: tMipManage('investors.expanded_row.workflow.additional_allocation'),
				LEAVER: tMipManage('investors.expanded_row.workflow.leaver'),
				PARTIAL_LEAVER: tMipManage('investors.expanded_row.workflow.partial_leaver'),
			};
			const investmentStatus = isReleased
				? tMipManage('investors.expanded_row.investment_status.released')
				: tMipManage('investors.expanded_row.investment_status.created');
			const investmentDate = formatStringDateToUI(date, DATE_FORMATS.CALENDAR_DATE);

			return `${workflowLabels[investmentWorkflowType]} (${investmentStatus}: ${investmentDate})`;
		},
		[tMipManage]
	);
};
